import { z } from "zod";

export const CreateAccountSkipSchema = z.object({
  first_name: z.string().min(1, { message: "The first name is required." }),
  last_name: z.string().min(1, { message: "The last name is required." }),
  country: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .refine((val) => val.id.trim() !== "" && val.name.trim() !== "", {
      message: "The location country is required.",
    }),
  phone: z
    .object({
      country_id: z.string().nonempty(),
      phone_number: z.string().min(4),
    })
    .refine(
      (val) => {
        return val.phone_number.length >= 4;
      },
      { message: "The Phone is required" }
    ),
});

export type CreateAccountSkipType = z.infer<typeof CreateAccountSkipSchema>;
